// TODO: Migrate to PetitionQRCodeDownload from '#src/app/shared/components/qrcode'
import type React from 'react';

import { QRCodeDownload } from './components/QRCodeDownload';
import { usePetitionUrlQRCode } from './hooks/usePetitionUrlQRCode';

export const PetitionUrlQRCode: React.FC = () => {
	const { data, actions } = usePetitionUrlQRCode();

	return (
		<div className="mt-6">
			<QRCodeDownload
				slugOrId={data.slugOrId}
				displaySize={data.displaySize}
				displayType={data.displayType}
				downloadType={data.downloadType}
				descriptionText={data.descriptionText}
				downloadLinkText={data.downloadLinkText}
				downloadFilename={data.downloadFilename}
				onClick={actions.trackDownload}
			/>
		</div>
	);
};
